import styled from "styled-components";

import LogoImg from "../../../assests/images/logo.png";

const Logo = styled.img.attrs({
  src: LogoImg,
  alt: "Logo"
})`
  height: 6.5rem;
  margin: 2rem 2rem 0 0;

  @media (max-width: 700px) {
    height: 4.5rem;
    magrin: 1rem 0rem 0rem 0rem;
  }
`;

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Navgation/Logo/Logo.js